/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Keypad = "keypad-trap",
    Hint = "hint",
};
